Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "SegmentedToggle1570627916",
  {"root":"SegmentedToggle1570627916--root","divider":"SegmentedToggle1570627916--divider"},
  ".SegmentedToggle1570627916--root{display:flex;box-sizing:border-box;border-radius:6px;box-shadow:0 0 0 1px var(--wsr-color-30,#c1e4fe);background:#fff;outline:0}.SegmentedToggle1570627916--root[data-segmentedtoggle1570627916-disabled]{box-shadow:0 0 0 1px rgba(22,45,61,.3)}.SegmentedToggle1570627916--divider{flex-basis:auto;width:1px;min-width:1px;background-color:var(--wsr-color-30,#c1e4fe)}.SegmentedToggle1570627916--divider[data-segmentedtoggle1570627916-disabled]{background-color:rgba(22,45,61,.3)}.SegmentedToggle1570627916--divider[data-segmentedtoggle1570627916-transparent]{background-color:transparent}",
  2,
  "SegmentedToggle1570627916"
);
__webpack_require__.stylable.$.register(exports.default)
